// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__G_350","header":"PatientQuestionnaire_header__1A0BZ","info":"PatientQuestionnaire_info__2PtX4"};